import { FaWhatsapp } from "react-icons/fa";

const WhatsappButton = () => {
  const phone = "5548999145340";
  const message = "Olá! Gostaria de saber mais sobre os seus serviços.";

  return (
    <a
      href={`https://wa.me/${phone}?text=${encodeURIComponent(message)}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex h-16 w-16 items-center justify-center rounded-full bg-green-500 text-white shadow-lg transition hover:scale-110 hover:bg-green-600"
      aria-label="Falar no WhatsApp"
    >
      <FaWhatsapp size={36} />
    </a>
  );
};

export default WhatsappButton;